var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import { connectComponent } from "../../redux/utils";
import menuActions from '../../redux/action/menu';
import errorActions from '../../redux/action/error';
import { Drawer, DrawerItem, DrawerItemDelimiter } from "grilnica-reactstrap";
import { mdiLoginVariant, mdiExitRun, mdiAccountCircle } from '@mdi/js';
import { getAuthPageUrl } from "../auth";
import { CONSTANTS } from "../../constants";
import { apiGet } from "../../api";
var MainMenu = /** @class */ (function (_super) {
    __extends(MainMenu, _super);
    function MainMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.loadData = function () { return __awaiter(_this, void 0, void 0, function () {
            var errorActions, subsystems;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        errorActions = this.props.errorActions;
                        return [4 /*yield*/, apiGet(CONSTANTS.authUrl + '/api/subsystem/use', null, errorActions.setError)];
                    case 1:
                        subsystems = _a.sent();
                        this.setState({
                            subsystems: subsystems
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.renderSubsystems = function () {
            var subsystems = _this.state.subsystems;
            if (subsystems) {
                return subsystems.map(function (subsystem) {
                    return React.createElement(DrawerItem, { key: subsystem.subsystemId, iconPath: '', href: subsystem.url, name: subsystem.name });
                });
            }
            else {
                return null;
            }
        };
        _this.state = {
            subsystems: []
        };
        return _this;
    }
    MainMenu.prototype.componentDidMount = function () {
        this.loadData();
    };
    MainMenu.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (this.props.user != prevProps.user) {
            this.loadData();
        }
    };
    MainMenu.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, user = _a.user, items = _a.items, actions = _a.actions;
        return (React.createElement(Drawer, { isOpen: isOpen, name: user ? user.lastName + ' ' + user.firstName : 'Гость', right: true, onClose: function () {
                actions.setState({ isOpen: false });
            } },
            items,
            items && React.createElement(DrawerItemDelimiter, null),
            user && React.createElement(DrawerItem, { iconPath: mdiAccountCircle, href: CONSTANTS.authUrl + '/profile', name: 'Профиль' }),
            React.createElement(DrawerItemDelimiter, null),
            this.renderSubsystems(),
            React.createElement(DrawerItemDelimiter, null),
            user ?
                React.createElement(DrawerItem, { iconPath: mdiExitRun, href: CONSTANTS.urlPrefix + '/logout', name: 'Выход' })
                :
                    React.createElement(DrawerItem, { iconPath: mdiLoginVariant, href: getAuthPageUrl(), name: 'Войти' })));
    };
    return MainMenu;
}(Component));
export default connectComponent(function (state) { return ({
    isOpen: state.menu.isOpen,
    user: state.auth.user
}); }, function (dispatch) { return ({
    actions: menuActions(dispatch),
    errorActions: errorActions(dispatch),
}); }, MainMenu);
//# sourceMappingURL=MainMenu.js.map